import React from 'react';
import { Col, Container, Row } from '@yme/atoms/grid';
import { Skeleton } from '@yme/common/components/skeletons';
import { useWindowSize } from '@yme/hooks/useWindowSize';
export function UnitRelatedExperienceSkeleton() {
    const { isMobileView } = useWindowSize();
    return (React.createElement(Container, null,
        React.createElement(Row, null,
            React.createElement(Col, null,
                React.createElement(Skeleton, { skeletonProps: {
                        height: isMobileView ? 28 : 32,
                        width: isMobileView ? '50%' : '30%',
                    } }))),
        React.createElement(Row, { mt: "24px", lgMt: "32px" },
            React.createElement(Col, null,
                React.createElement(Skeleton, { skeletonProps: {
                        height: isMobileView ? 380 : 450,
                    } }),
                isMobileView && (React.createElement(Skeleton, { skeletonProps: {
                        height: 44,
                    }, wrapperProps: {
                        mtS: 48,
                    } }))))));
}
